var _defs, _polyline, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _polygon2, _polygon3, _polyline2, _polygon4, _polyline3, _polygon5, _polygon6, _polyline4, _polygon7, _polygon8, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse, _path19, _path20, _path21, _path22, _ellipse2, _path23, _path24, _path25, _path26, _path27, _path28, _ellipse3, _path29, _path30, _path31, _path32, _path33, _path34, _ellipse4, _ellipse5, _path35, _path36, _path37, _path38, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinnerIsometric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 273.56,
    y1: 263.59,
    x2: 258.08,
    y2: 237.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ffa86a"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "202.87 35.55 207.03 37.82 206.06 41.38 202.43 39.97",
    fill: "#ed9a94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.33,41.5l.4-5.38s8.87,1.46,10.89,1.7,3.23-12.43,8.65-11.73-1.75,17-1.75,17L210,44.93",
    fill: "#68e1fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.1,142.6l15.56,65.73c.37,1.58-2.06,2.26-2.44.67l-15.56-65.73c-.37-1.58,2.06-2.26,2.44-.67Z",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.5,150.38l15.56,65.73c.37,1.58-2.06,2.26-2.44.67l-15.56-65.73c-.37-1.58,2.06-2.26,2.44-.67Z",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270.71,153l-14.6,8.15c-1.42.79-2.7-1.39-1.28-2.18l14.6-8.15c1.42-.79,2.7,1.39,1.28,2.18Z",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.24,162.1l-14,7.82c-1.42.79-2.7-1.39-1.28-2.18l14-7.82c1.42-.79,2.7,1.39,1.28,2.18Z",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.93,169.5l-14,7.81c-1.42.79-2.7-1.39-1.28-2.18l14-7.81c1.42-.79,2.7,1.39,1.28,2.18Z",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M276.13,177.46l-13.85,7.74c-1.42.79-2.7-1.39-1.28-2.18l13.85-7.74c1.42-.79,2.7,1.39,1.28,2.18Z",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M278,184.75l-13.88,7.75c-1.42.79-2.7-1.39-1.28-2.18l13.88-7.75c1.42-.79,2.7,1.39,1.28,2.18Z",
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280.15,193.21l-14.6,8.15c-1.42.79-2.7-1.39-1.28-2.18l14.6-8.15c1.42-.79,2.7,1.39,1.28,2.18Z",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.64,162.42,162.25,83.55a6.41,6.41,0,0,1,6.41,0L371.45,199.6a6.41,6.41,0,0,1,0,11.12L241.79,285.59a20.93,20.93,0,0,1-20.93,0L26.66,173.51A6.41,6.41,0,0,1,26.64,162.42Z",
    fill: "#ffb3a6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.81,289.9c36.08-23.84,56.93-26.18,90.49-50.83C321,228,284.92,206.43,271.79,198.22l-89.44,52.24,67.76,39.47Z",
    opacity: 0.63,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "130.28 221.21 196.22 258.51 273.22 213.67 273.22 183.52 196.22 228.36 130.28 190.67 130.28 221.21",
    fill: "#0a6fc1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "130.28 190.67 208.75 145.65 273.22 183.52 196.22 228.36 130.28 190.67",
    fill: "#005fbb"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.22 228.36 196.22 258.51 273.22 213.67 273.22 183.52 196.22 228.36",
    fill: "#094697"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "177.95 102.25 177.95 153.5 244.01 183.52 273.22 153.09 273.22 122.6",
    fill: "#68e1fd"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "243.34 140.25 243.34 201.6 273.22 183.52 273.22 122.6 243.34 140.25",
    fill: "#68e1fd"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "177.95 102.25 177.95 153.5 243.34 183.21 243.34 183.21 243.34 140.25",
    opacity: 0.15
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "243.34 140.25 273.22 122.6 208.05 85.14 177.95 102.25 243.34 140.25",
    fill: "#68e1fd"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "243.34 140.25 243.34 201.6 273.22 183.52 273.22 122.6 243.34 140.25",
    opacity: 0.25
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "148.07 150.42 148.07 180.53 214.13 218.12 243.34 201.26 243.34 170.77",
    fill: "#ee4165"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.46 188.42 243.34 170.77 178.16 133.31 148.07 150.42 213.46 188.42",
    fill: "#fa6d90"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.46 188.42 213.46 218.12 273.22 183.52 273.22 153.09 213.46 188.42",
    fill: "#d82352"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M222.92,50.66S219.69,67.86,220,77.29s.46,21,1.17,26.09c0,0,3.19,1.58,5.31-.29,0,0,3.69-33.76,3.73-33.57,1,4.35,6.17,24.27,6.65,25.73s3.89,15.88,3.89,15.88.74,2.55,5.39-.33c0,0-1.21-24.86-2.3-31.34-.83-4.9-4.75-26.45-7.21-28.79",
    fill: "#181816"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M236.46,52S242,36,239.75,32.29s-11.19-6.57-15.48-6.2-1.54,25.77-.86,26S230.43,56.58,236.46,52Z",
    fill: "#68e1fd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.52,49.63v3.8a14.12,14.12,0,0,0,14.51,0l-.41-2.77S230.88,53.6,222.52,49.63Z",
    fill: "#af2b38"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M245.21,94.76l-1.41,1.41c-.75,0-1,9.56-1.69,9.9s-4.57-10.28-5.2-10l4.16,16.07c-.72,1.72-1.67,9.37-.78,10.76,1.12,1.74,3.74,2,5.44,1,1.33-.77,1.41-2.26,1.28-3.65-.48-5.12-.85-10.34-1.1-15.48A95.8,95.8,0,0,0,245.21,94.76Z",
    fill: "#181816"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M227.86,90.39l-2.33.57c-1.76.75-1.93,8.47-2.61,8.8s-1.92-9.33-2.54-9c0,0,.92,13.71.11,15.16-.9,1.62-6.86,4.79-6,6.18a4,4,0,0,0,5.44,1.26c2.37-1.3,3.92-4,5.61-4.64,1.45-.58.84-4.35.89-5.62C226.56,100.9,228.2,92.57,227.86,90.39Z",
    fill: "#181816"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M224.76,19.66s0,9.39,3.44,10c3.78.67,5.91-3.63,5.91-3.63s.49-8.29-3.27-9S224.87,18.45,224.76,19.66Z",
    fill: "#fbb5ad"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M225.17,20.82c-1.17-.32-2.57-.66-3.26-1.77-1-1.66.11-3.38,1.48-4.39a7.35,7.35,0,0,1,5.71-1.12c2.7.46,6.53,1.6,7.27,4.65,1,4.21-3,9.51-3,9.51V25.09s1.36-1.74.64-2.41-1,.95-1,.95.31-3.11-1.91-3.45c-.91-.14-1.25.37-2,.77a3.18,3.18,0,0,1-1.7.31A11.52,11.52,0,0,1,225.17,20.82Z",
    fill: "#5c2e2e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105,144c-6.92-.6-14.22-2.7-19.33-7.43v20.53a21.3,21.3,0,0,0,21.3,21.3h0a21.3,21.3,0,0,0,21.3-21.3V136.18C121,139.14,112.76,144.63,105,144Z",
    fill: "#68e1fd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.97,
    cy: 136.39,
    rx: 21.3,
    ry: 11.29,
    fill: "#5ed18d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107,138.31s-14.49-2.13-18.32-25.56C88.65,112.74,101,119.56,107,138.31Z",
    fill: "#5ed18d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.1,135.32s-16.62-29.82,0-49.85A83.56,83.56,0,0,1,109.1,135.32Z",
    fill: "#5ed18d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107,116.58S92.48,114.45,88.65,91C88.65,91,101,97.83,107,116.58Z",
    fill: "#5ed18d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.73,126.13s-3.63-14.19,16.51-26.77C125.24,99.36,123.72,113.39,108.73,126.13Z",
    fill: "#5ed18d"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.97,
    cy: 136.39,
    rx: 21.3,
    ry: 11.29,
    fill: "#146666"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107,138.31s-14.49-2.13-18.32-25.56C88.65,112.74,101,119.56,107,138.31Z",
    fill: "#5ed18d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M109.1,135.32s-16.62-29.82,0-49.85A83.56,83.56,0,0,1,109.1,135.32Z",
    fill: "#5ed18d"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107,116.58S92.48,114.45,88.65,91C88.65,91,101,97.83,107,116.58Z",
    fill: "#5ed18d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.73,126.13s-3.63-14.19,16.51-26.77C125.24,99.36,123.72,113.39,108.73,126.13Z",
    fill: "#5ed18d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M224,34.74a.5.5,0,0,0-1,0l.15,11.82a.5.5,0,0,0,1,0Z",
    fill: "#181816"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M218.94,61.53a5.84,5.84,0,0,1,1.08,1.8c.09.62,0,3.74-5.47,3.71s-5.13-3.34-5-3.59,1.24-2.11,1.24-2.11",
    fill: "#fa6c00"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.81,
    cy: 62.05,
    rx: 4.23,
    ry: 2.43,
    fill: "#f7dd02"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M220.21,55.34c1.54-1.09,3.91.72,5.55.79a2.23,2.23,0,0,0,2.37-1.48,4.7,4.7,0,0,0,.39-1.6c0-.65-.55-1-1-1.42-1.39-1.19-3.41-1.63-4.56-3.07-.54-.68.42-1.65,1-1,1,1.27,2.91,1.74,4.18,2.75a5,5,0,0,1,1.63,1.78,3.78,3.78,0,0,1-.13,2.39,3.66,3.66,0,0,1-2.93,2.93,5.73,5.73,0,0,1-2.33-.17c-.52-.14-1-.32-1.54-.49l-.68-.21-.35-.09q-.46-.2-.49.55c.86.17.5,1.49-.36,1.32A1.68,1.68,0,0,1,220.21,55.34Z",
    fill: "#fa6c00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M202.87,35.55A9.7,9.7,0,0,1,205.41,37c.83.55,1.62,1.15,2.4,1.77s-.28,1.51-1,1a29,29,0,0,0-3.61-2.49c-.31-.18-.73-.6-1.08-.24s-.18.72-.17,1a6.53,6.53,0,0,0,.45,2c.95,2.59,3,4.54,5,6.4.64.61-.33,1.57-1,1-2.59-2.48-5.54-5.39-5.81-9.19C200.53,36.81,201.25,35.1,202.87,35.55Z",
    fill: "#fa6c00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.84,57.52a5.49,5.49,0,0,0,.37,2.64,12.18,12.18,0,0,0,.95,1.52s.14,1.64-2.41,1.64-2.13-1.58-2.13-1.58a5.05,5.05,0,0,0,.92-4.22",
    fill: "#fec617"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M212.62,61.75a5.05,5.05,0,0,0,.92-4.22h.77c-.05,1.94.06,4.24,1.3,5.73a4.52,4.52,0,0,1-.87.08C212.19,63.33,212.62,61.75,212.62,61.75Z",
    fill: "#ffa407"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M223.9,41.38v7s-.12,9.53-9.12,9.53-8.72-9.6-8.72-9.6V41.38",
    fill: "#fec617"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M206.07,48.27V41.38h5.15c0,4.49.21,9.46,3.12,13a12.79,12.79,0,0,0,3.6,3,10.12,10.12,0,0,1-3.15.47C205.79,57.87,206.07,48.27,206.07,48.27Z",
    fill: "#ffa407"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.98,
    cy: 41.38,
    rx: 8.92,
    ry: 5.26,
    fill: "#f7dd02"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.78,
    cy: 41.24,
    rx: 7.44,
    ry: 4.16,
    fill: "#fa6c00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M227.52,51.62s-1.8,2.76-1,4.44a3.36,3.36,0,0,0,3.13,1.82c.71,0,2.16-4.46,2.16-4.46s-1.83-4.12-3.05-3.79-.68.71-.68.71,1.81,1.58,1.15,1.81S227.52,51.62,227.52,51.62Z",
    fill: "#fbb5ad"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M230.68,51.26l3.23.9s1.9,4.58.77,4.93a48.08,48.08,0,0,1-5,.79",
    fill: "#fbb5ad"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M202.87,35.55s.15-1.05-1.13-.83-2.66,2.83-2.16,4.88,2.37,1.29,3,.87.61-3.22.61-3.22,1.79-1.48,1.09-2.09S202.87,35.55,202.87,35.55Z",
    fill: "#fbb5ad"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M238.88,31.21s13.34,12.33,10.73,18.4-15.47,8.75-15.47,8.75-1.52-5.58-.19-7.42,5.47-2.85,5.47-2.85l-3.71-4.86",
    fill: "#68e1fd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M240.29,47.13q-2-3.77-4.22-7.44a.5.5,0,0,0-.86.5q2.17,3.61,4.16,7.33A59,59,0,0,0,233,50.09a.49.49,0,0,0-.25.43,50.44,50.44,0,0,0,.69,7.24c.11.63,1.07.36,1-.27-.19-1.13-.35-2.27-.46-3.41-.08-.86-.44-2.43,0-3.14s2.16-1.16,3-1.48c1-.39,2-.73,3-1.06a.5.5,0,0,0,.31-.67A.48.48,0,0,0,240.29,47.13Z",
    fill: "#181816"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerIsometric);
export default __webpack_public_path__ + "static/media/Winner_Isometric.fe6e744b83a30de2755c724c65ce28dd.svg";
export { ForwardRef as ReactComponent };